import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import { BaseUrlProvider } from "./context/AppContext";
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/fonts/fontStyles.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BaseUrlProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
    </BaseUrlProvider>
  </React.StrictMode>
);

reportWebVitals();
